import table from './table';
import tab from './tab';
import mySelect from './mySelect';
import mySelectNum from './mySelectNum';
import mySelectAll from './mySelectAll';
import mySpan from './dynamicForm/mySpan';
import myInputSpan from './dynamicForm/myInputSpan'
import myPhotoPreview from './dynamicForm/myPhotoPreview';
import myPhotoMultiPreview from './dynamicForm/myPhotoMultiPreview';
import myDateTime from './dynamicForm/myDateTime';
import componentForm from './dynamicForm/componentForm';
import uploadImg from './dynamicForm/uploadImg'
import myPhotoView from './dynamicForm/myPhotoView'


const myComponent = {
    install:function(Vue){
      Vue.component('MyTab',tab)
      Vue.component('MyTable', table);
      Vue.component('MySelect', mySelect);
      Vue.component('MySelectnum', mySelectNum);
      Vue.component('MySelectAll',mySelectAll)
      Vue.component('MySpan', mySpan);
      Vue.component('MyInputSpan',myInputSpan) 
      Vue.component('MyDateTime',myDateTime)
      Vue.component('MyPhotoPreview', myPhotoPreview);
      Vue.component('MyPhotoMultiPreview', myPhotoMultiPreview);
      Vue.component('ComponentForm', componentForm);
      Vue.component('UploadImg',uploadImg);
      Vue.component('MyPhotoView',myPhotoView)
      // Vue.component('MySelect',mySelect)
    }
  };
export default myComponent;